module.exports = __webpack_public_path__ + "img/img2.f5036d45.jpg";